import { render, staticRenderFns } from "./ProjectOptions.vue?vue&type=template&id=104c1f49&scoped=true&"
import script from "./ProjectOptions.vue?vue&type=script&lang=js&"
export * from "./ProjectOptions.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOptions.vue?vue&type=style&index=0&id=104c1f49&lang=scss&scoped=true&"
import style1 from "./ProjectOptions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104c1f49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('104c1f49')) {
      api.createRecord('104c1f49', component.options)
    } else {
      api.reload('104c1f49', component.options)
    }
    module.hot.accept("./ProjectOptions.vue?vue&type=template&id=104c1f49&scoped=true&", function () {
      api.rerender('104c1f49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/ProjectOptions.vue"
export default component.exports